// Shared API base for the admin module
export const API = `${window.location.origin}/api`;
